// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
import Search from './Search';
import Notification from './Notification';
// import MobileSection from './MobileSection';
import Profile from './Profile/Profile';
import Message from './Message';
import Reminder from './Reminder';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
	const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));

	return (
		<Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
			<Search id="search_bar" compact />
			<Reminder />
			<Message />
			<Notification />
			<Profile />
			{matchesXs && <Box sx={{ width: 0 }} />}
			{/* {matchesXs && <MobileSection />} */}
		</Box>
	);
};

export default HeaderContent;
